import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Methode from './pages/Methode';
import Forfaits from './pages/Forfaits';
import Ville from './pages/Ville';
import Login from './pages/Login';
import Legal from './pages/Legal';
import Cgv from './pages/Cgv';
import Faq from './pages/Faq';
import Linge from './pages/Linge';
import Engagements from './pages/Engagements';
import ScrollToTop from './components/utils/ScrollToTop';
import Audit from './pages/Audit';
import Recrutement from './pages/Recrutement';
import Blog from './pages/Blog';
import Article from './pages/Article';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import CollaboratorDashboard from './pages/CollaboratorDashboard';
import Landing from './pages/Landing';
import InterventionReport from './pages/InterventionReport';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/vip" element={<Landing />} />
        <Route path="/methode" element={<Methode />} />
        <Route path="/forfaits" element={<Forfaits />} />
        <Route path="/villes/:id" element={<Ville />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/collaborator" element={<CollaboratorDashboard />} />
        <Route path="/collaborator/report/:id" element={<InterventionReport />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/cgv" element={<Cgv />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/realisations" element={<Blog />} />
        <Route path="/realisations/:id" element={<Article />} />
        <Route path="/soin-du-linge" element={<Linge />} />
        <Route path="/engagements" element={<Engagements />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/recrutement" element={<Recrutement />} />
      </Routes>
    </Router>
  );
}

export default App;
